(function() {
  'use strict';

  var ROOT_SELECTOR = '[data-mellow-stack-builder]';
  var STACK_ID_PROPERTY = '_mellow_stack_id';
  var STACK_TIER_PROPERTY = '_mellow_stack_tier';
  var STACK_POSITION_PROPERTY = '_mellow_stack_position';
  var STACK_CODE_PROPERTY = '_mellow_stack_discount_code';
  var STACK_EDIT_URL_PROPERTY = '_mellow_stack_edit_url';
  var STACK_INTERNAL_PROPERTIES = [
    STACK_ID_PROPERTY,
    STACK_TIER_PROPERTY,
    STACK_POSITION_PROPERTY,
    STACK_CODE_PROPERTY,
    STACK_EDIT_URL_PROPERTY
  ];
  var stackCheckoutInProgress = false;

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function(character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[character];
    });
  }

  function cartRoute(suffix) {
    var routes = window.theme && window.theme.routes ? window.theme.routes : {};
    return (routes.cart || '/cart') + suffix;
  }

  function isStackInternalProperty(name) {
    return STACK_INTERNAL_PROPERTIES.indexOf(String(name || '')) !== -1;
  }

  function cartItemPayload(item, keepStackProperties) {
    var payload = {
      id: String(item.variant_id),
      quantity: Number(item.quantity || 1)
    };
    var properties = {};

    Object.keys(item.properties || {}).forEach(function(name) {
      var value = item.properties[name];
      if ((!keepStackProperties && isStackInternalProperty(name)) || value == null || value === '') {
        return;
      }
      properties[name] = value;
    });

    if (Object.keys(properties).length) {
      payload.properties = properties;
    }

    var sellingPlan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
    if (sellingPlan && sellingPlan.id) {
      payload.selling_plan = sellingPlan.id;
    }

    return payload;
  }

  async function cartJsonRequest(suffix, body) {
    var response = await window.fetch(cartRoute(suffix), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(body)
    });
    var data = await response.json();

    if (!response.ok) {
      throw new Error(data.description || data.message || 'Your bag could not be prepared for checkout.');
    }

    return data;
  }

  function hasRenderedStack() {
    return Boolean(document.querySelector('[data-mellow-stack-cart-group]'));
  }

  function syncStackAcceleratedCheckoutButtons() {
    var hide = hasRenderedStack();
    document.querySelectorAll('.drawer__checkout__additional, .cart__footer__additional').forEach(function(container) {
      container.hidden = hide;
      container.setAttribute('aria-hidden', hide ? 'true' : 'false');
    });
  }

  async function cleanStackItemsForCheckout() {
    var response = await window.fetch(cartRoute('.js'), { credentials: 'same-origin' });
    if (!response.ok) {
      throw new Error('Your bag could not be refreshed before checkout.');
    }

    var cart = await response.json();
    var stackItems = (cart.items || []).filter(function(item) {
      return Boolean((item.properties || {})[STACK_ID_PROPERTY]);
    });

    if (!stackItems.length) {
      return false;
    }

    var discountCode = String((stackItems[0].properties || {})[STACK_CODE_PROPERTY] || '');
    var updates = {};
    var cleanItems = [];
    var originalItems = [];

    stackItems.forEach(function(item) {
      updates[item.key] = 0;
      cleanItems.push(cartItemPayload(item, false));
      originalItems.push(cartItemPayload(item, true));
    });

    var removed = false;
    var cleanItemsAdded = false;

    try {
      await cartJsonRequest('/update.js', { updates: updates });
      removed = true;
      await cartJsonRequest('/add.js', { items: cleanItems });
      cleanItemsAdded = true;

      if (discountCode) {
        try {
          await cartJsonRequest('/update.js', { discount: discountCode });
        } catch (discountError) {
          console.error(discountError);
        }
      }
    } catch (error) {
      if (removed && !cleanItemsAdded) {
        try {
          await cartJsonRequest('/add.js', { items: originalItems });
          if (discountCode) {
            await cartJsonRequest('/update.js', { discount: discountCode });
          }
        } catch (restoreError) {
          console.error(restoreError);
        }
      }
      throw error;
    }

    return true;
  }

  async function beginStackCheckout(button) {
    if (stackCheckoutInProgress) {
      return;
    }

    stackCheckoutInProgress = true;
    var originalHtml = button ? button.innerHTML : '';
    if (button) {
      button.disabled = true;
      button.textContent = 'Preparing checkout…';
      button.setAttribute('aria-busy', 'true');
    }

    try {
      await cleanStackItemsForCheckout();
      var storefrontRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';
      window.location.assign(storefrontRoot + 'checkout');
    } catch (error) {
      console.error(error);
      stackCheckoutInProgress = false;
      if (button) {
        button.disabled = false;
        button.innerHTML = originalHtml;
        button.removeAttribute('aria-busy');
      }
      window.alert(error && error.message ? error.message : 'Your stack could not be prepared for checkout. Please try again.');
    }
  }

  function formatMoney(cents, format) {
    var formatted;
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      formatted = window.Shopify.formatMoney(cents, format);
      var moneyElement = document.createElement('span');
      moneyElement.innerHTML = formatted;
      return moneyElement.textContent || moneyElement.innerText || '';
    }

    var template = format || '${{amount}}';
    var match = template.match(/\{\{\s*(amount(?:_no_decimals)?(?:_with_(?:comma|space|apostrophe)_separator)?)\s*\}\}/);
    var token = match ? match[1] : 'amount';
    var decimals = token.indexOf('no_decimals') === -1 ? 2 : 0;
    var decimalMark = token.indexOf('comma_separator') !== -1 ? ',' : '.';
    var thousandsMark = token.indexOf('comma_separator') !== -1 ? '.' : (token.indexOf('space_separator') !== -1 ? ' ' : (token.indexOf('apostrophe_separator') !== -1 ? "'" : ','));
    var number = (Number(cents || 0) / 100).toFixed(decimals).split('.');
    var whole = number[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsMark);
    var value = whole + (decimals ? decimalMark + number[1] : '');

    formatted = match ? template.replace(match[0], value) : ('$' + value);
    var fallbackMoneyElement = document.createElement('span');
    fallbackMoneyElement.innerHTML = formatted;
    return fallbackMoneyElement.textContent || fallbackMoneyElement.innerText || '';
  }

  function createStackId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }

    return 'stack-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);
  }

  function publicProperties(entries) {
    var properties = [];

    (entries || []).forEach(function(entry) {
      var match = String(entry[0]).match(/^properties\[(.*)\]$/);
      var value = entry[1];
      if (!match || !match[1] || match[1].charAt(0) === '_' || value == null || value === '') {
        return;
      }

      properties.push({
        name: match[1],
        value: value instanceof File ? value.name : String(value)
      });
    });

    return properties;
  }

  function variantLabels(product, variant) {
    var regular = [];
    var sizes = [];
    var optionNames = (product && product.options) || [];
    var optionValues = (variant && variant.options) || [];

    optionValues.forEach(function(value, index) {
      if (!value || value === 'Default Title') {
        return;
      }

      var rawName = optionNames[index];
      var name = typeof rawName === 'string' ? rawName : (rawName && rawName.name) || '';
      if (String(name).toLowerCase().indexOf('size') !== -1) {
        sizes.push((name || 'Size') + ': ' + value);
      } else {
        regular.push(value);
      }
    });

    return regular.concat(sizes).join(' · ');
  }

  function selectionFromQuickAdd(detail) {
    var product = detail.product || {};
    var variant = detail.variant || {};
    var entries = detail.entries || [];
    var card = detail.sourceButton ? detail.sourceButton.closest('[data-stack-card]') : null;
    var image = '';

    if (variant.featured_image) {
      image = variant.featured_image.src || variant.featured_image.url || variant.featured_image;
    }
    if (!image && product.featured_image) {
      image = product.featured_image;
    }
    if (!image && card) {
      var cardImage = card.querySelector('.mellow-stack-card__image');
      image = cardImage ? (cardImage.currentSrc || cardImage.src) : '';
    }

    return {
      productId: String(product.id || (card && card.dataset.productId) || ''),
      handle: product.handle || (card && card.dataset.productHandle) || '',
      title: product.title || (card && card.querySelector('.mellow-stack-card__title') || {}).textContent || '',
      url: product.url || (card && card.querySelector('.mellow-stack-card__title') || {}).href || '',
      image: image,
      price: Number(variant.price || detail.price || 0),
      compareAtPrice: Number(variant.compare_at_price || detail.compareAtPrice || 0),
      variantId: String(variant.id || detail.variantId || ''),
      variantTitle: variant.title || '',
      variantLabel: variantLabels(product, variant),
      entries: entries,
      properties: publicProperties(entries),
      product: product,
      variant: variant
    };
  }

  function cloneFormData(entries) {
    var formData = new FormData();

    (entries || []).forEach(function(entry) {
      var value = entry[1];
      if (value instanceof File) {
        formData.append(entry[0], value, value.name);
      } else {
        formData.append(entry[0], value);
      }
    });

    return formData;
  }

  function Builder(root) {
    this.root = root;
    this.moneyFormat = root.dataset.moneyFormat || '${{amount}}';
    this.codes = {
      2: root.dataset.discountCodeTwo || 'MELLOWSTACK15',
      3: root.dataset.discountCodeThree || 'MELLOWSTACK20',
      4: root.dataset.discountCodeFour || 'MELLOWSTACK25',
      5: root.dataset.discountCodeFive || 'MELLOWSTACK30'
    };
    this.maxItems = Number(root.dataset.stackMaxItems || 5);
    this.editPageUrl = root.dataset.editPageUrl || '/pages/build-your-stack';
    this.selections = [];
    this.replaceIndex = null;
    this.editingStackId = null;
    this.isSubmitting = false;
    this.activeFilter = 'all';
    this.lastCelebratedTier = 0;
    this.celebrationTimer = null;

    this.slots = Array.prototype.slice.call(root.querySelectorAll('[data-stack-slot]'));
    this.cards = Array.prototype.slice.call(root.querySelectorAll('[data-stack-card]'));
    this.message = root.querySelector('[data-stack-message]');
    this.count = root.querySelector('[data-stack-count]');
    this.originalTotal = root.querySelector('[data-stack-original]');
    this.currentTotal = root.querySelector('[data-stack-total]');
    this.saving = root.querySelector('[data-stack-saving]');
    this.submit = root.querySelector('[data-stack-submit]');
    this.mobileSubmit = root.querySelector('[data-stack-mobile-submit]');
    this.mobileCount = root.querySelector('[data-stack-mobile-count]');
    this.mobileTotal = root.querySelector('[data-stack-mobile-total]');
    this.error = root.querySelector('[data-stack-error]');
    this.search = root.querySelector('[data-stack-search]');
    this.sort = root.querySelector('[data-stack-sort]');
    this.grid = root.querySelector('[data-stack-grid]');
    this.empty = root.querySelector('[data-stack-empty]');
    this.nextReward = root.querySelector('[data-stack-next-reward]');
    this.tierFill = root.querySelector('[data-stack-tier-fill]');
    this.celebration = root.querySelector('[data-stack-celebration]');
    this.celebrationTitle = root.querySelector('[data-stack-celebration-title]');
    this.celebrationCopy = root.querySelector('[data-stack-celebration-copy]');

    this.prepareCards();
    this.bind();
    this.render();
    this.loadEditStack();
  }

  Builder.prototype.prepareCards = function() {
    this.cards.forEach(function(card, index) {
      var productJson = card.querySelector('[data-stack-card-product-json]');
      var button = card.querySelector('[data-mellow-quick-add]');
      var image = card.querySelector('.mellow-stack-card__image');

      card.dataset.stackOriginalOrder = String(index);
      try {
        card.stackProduct = productJson ? JSON.parse(productJson.textContent) : null;
      } catch (error) {
        card.stackProduct = null;
        console.warn('Could not read stack product data', error);
      }

      card.stackDefaultVariantId = button ? String(button.dataset.variantId || '') : '';
      card.stackDefaultImage = image ? {
        src: image.getAttribute('src') || '',
        srcset: image.getAttribute('srcset') || '',
        sizes: image.getAttribute('sizes') || ''
      } : null;
    });
  };

  Builder.prototype.bind = function() {
    var builder = this;

    this.root.addEventListener('click', function(event) {
      var swatch = event.target.closest('[data-stack-swatch]');
      if (swatch) {
        event.preventDefault();
        event.stopPropagation();
        builder.applySwatch(swatch);
        return;
      }

      var removeSlot = event.target.closest('[data-stack-remove-slot]');
      if (removeSlot) {
        builder.removeAt(Number(removeSlot.dataset.stackRemoveSlot));
        return;
      }

      var editSlot = event.target.closest('[data-stack-edit-slot]');
      if (editSlot) {
        builder.editAt(Number(editSlot.dataset.stackEditSlot));
        return;
      }

      if (event.target.closest('[data-stack-scroll-products]')) {
        var catalog = builder.root.querySelector('[data-stack-catalog]');
        if (catalog) {
          catalog.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }

      var filter = event.target.closest('[data-stack-filter]');
      if (filter) {
        builder.activeFilter = filter.dataset.stackFilter;
        builder.root.querySelectorAll('[data-stack-filter]').forEach(function(button) {
          var active = button === filter;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        builder.applyCatalogControls();
      }
    });

    if (this.submit) {
      this.submit.addEventListener('click', function() { builder.submitStack(); });
    }
    if (this.mobileSubmit) {
      this.mobileSubmit.addEventListener('click', function() { builder.submitStack(); });
    }
    if (this.search) {
      this.search.addEventListener('input', function() { builder.applyCatalogControls(); });
    }
    if (this.sort) {
      this.sort.addEventListener('change', function() { builder.applyCatalogControls(); });
    }

    document.addEventListener('mellow:stack:item-selected', function(event) {
      if (!event.detail || event.detail.builderRoot !== builder.root) {
        return;
      }
      builder.addSelection(selectionFromQuickAdd(event.detail));
    });

    document.addEventListener('mellow:quick-add:closed', function(event) {
      if (event.detail && event.detail.builderRoot === builder.root) {
        builder.replaceIndex = null;
      }
    });
  };

  Builder.prototype.addSelection = function(selection) {
    if (!selection.variantId) {
      this.showError('Please choose an available piece option.');
      return;
    }

    var targetIndex = this.replaceIndex;

    if (targetIndex != null && targetIndex >= 0 && targetIndex < this.maxItems) {
      this.selections[targetIndex] = selection;
      this.selections = this.selections.filter(Boolean);
    } else if (this.selections.length < this.maxItems) {
      this.selections.push(selection);
    }

    this.replaceIndex = null;
    this.showError('');
    this.render();
  };

  Builder.prototype.removeAt = function(index) {
    if (index < 0 || index >= this.selections.length) {
      return;
    }
    this.selections.splice(index, 1);
    this.replaceIndex = null;
    this.showError('');
    this.render();
  };

  Builder.prototype.editAt = function(index) {
    var selection = this.selections[index];
    if (!selection) {
      return;
    }

    var card = this.cards.find(function(item) {
      return item.dataset.productId === selection.productId;
    });
    var button = card && card.querySelector('[data-mellow-quick-add]');
    if (!button || !window.MellowQuickAdd || typeof window.MellowQuickAdd.openForStack !== 'function') {
      this.showError('This selection could not be opened. Please remove it and choose the piece again.');
      return;
    }

    this.replaceIndex = index;
    window.MellowQuickAdd.openForStack(button, this.root, selection).catch(function(error) {
      console.error(error);
    });
  };

  Builder.prototype.discountRate = function() {
    if (this.selections.length >= 5) {
      return 30;
    }
    if (this.selections.length >= 4) {
      return 25;
    }
    if (this.selections.length >= 3) {
      return 20;
    }
    if (this.selections.length >= 2) {
      return 15;
    }
    return 0;
  };

  Builder.prototype.discountedTotal = function() {
    var rate = this.discountRate();
    return this.selections.reduce(function(sum, item) {
      return sum + Math.round(Number(item.price || 0) * (100 - rate) / 100);
    }, 0);
  };

  Builder.prototype.originalPrice = function() {
    return this.selections.reduce(function(sum, item) {
      return sum + Number(item.price || 0);
    }, 0);
  };

  Builder.prototype.celebrateTier = function(tier, rate) {
    if (tier < 2 || !rate) {
      return;
    }

    var builder = this;
    var tierMessages = {
      2: {
        title: '15% off your stack!',
        copy: 'Two pieces chosen. Your 15% saving is now applied.'
      },
      3: {
        title: 'Your stack now saves 20%!',
        copy: 'Three pieces chosen. Your saving has increased to 20%.'
      },
      4: {
        title: '25% off your stack!',
        copy: 'Four pieces chosen. Your stack now receives 25% off.'
      },
      5: {
        title: 'You’ve reached 30% off!',
        copy: 'Five pieces chosen. Our highest stack saving is now applied.'
      }
    };
    var tierMessage = tierMessages[tier] || {
      title: rate + '% off your stack!',
      copy: 'Your stack saving is now applied.'
    };
    var tierElement = this.root.querySelector('[data-stack-tier="' + tier + '"]');
    window.clearTimeout(this.celebrationTimer);
    this.root.classList.remove('is-celebrating');
    void this.root.offsetWidth;
    this.root.classList.add('is-celebrating');

    if (tierElement) {
      tierElement.classList.add('is-celebrating');
    }
    if (this.celebration) {
      this.celebration.hidden = true;
      if (this.celebration.parentNode !== document.body) {
        document.body.appendChild(this.celebration);
      }
      void this.celebration.offsetWidth;
      this.celebration.hidden = false;

      var celebration = this.celebration;
      var positionCelebration = function() {
        var pageHeader = document.querySelector('.theme__header') || document.querySelector('header');
        var headerRect = pageHeader ? pageHeader.getBoundingClientRect() : null;
        var celebrationTop = headerRect && headerRect.bottom > 0
          ? headerRect.bottom + 12
          : 18;
        celebrationTop = Math.min(
          celebrationTop,
          Math.max(18, window.innerHeight - celebration.offsetHeight - 18)
        );
        celebration.style.setProperty('--stack-celebration-top', celebrationTop + 'px');
      };
      positionCelebration();
      window.requestAnimationFrame(positionCelebration);
      window.setTimeout(positionCelebration, 320);
    }
    if (this.celebrationTitle) {
      this.celebrationTitle.textContent = tierMessage.title;
    }
    if (this.celebrationCopy) {
      this.celebrationCopy.textContent = tierMessage.copy;
    }

    this.celebrationTimer = window.setTimeout(function() {
      builder.root.classList.remove('is-celebrating');
      if (tierElement) {
        tierElement.classList.remove('is-celebrating');
      }
      if (builder.celebration) {
        builder.celebration.hidden = true;
      }
    }, 3600);
  };

  Builder.prototype.render = function() {
    var builder = this;
    var count = this.selections.length;
    var rate = this.discountRate();
    var original = this.originalPrice();
    var current = this.discountedTotal();

    this.slots.forEach(function(slot, index) {
      builder.renderSlot(slot, index, builder.selections[index]);
    });

    if (this.count) {
      this.count.textContent = count + ' of ' + this.maxItems + ' pieces chosen';
    }
    if (this.mobileCount) {
      this.mobileCount.textContent = count + ' of ' + this.maxItems + ' pieces';
    }

    if (count === 0) {
      this.message.textContent = 'Choose any 2 pieces to unlock 15% off.';
    } else if (count === 1) {
      this.message.textContent = 'Choose 1 more piece to unlock 15% off.';
    } else if (count === 2) {
      this.message.textContent = '15% unlocked! Add 1 more piece to unlock 20% off.';
    } else if (count === 3) {
      this.message.textContent = '20% unlocked! Add 1 more piece to unlock 25% off.';
    } else if (count === 4) {
      this.message.textContent = '25% unlocked! Add 1 more piece to unlock 30% off.';
    } else {
      this.message.textContent = 'Amazing—your 5-piece collection unlocked 30% off.';
    }

    if (this.nextReward) {
      if (count < 2) {
        this.nextReward.textContent = 'Next reward: 15% off';
      } else if (count === 2) {
        this.nextReward.textContent = 'Next reward: 20% off';
      } else if (count === 3) {
        this.nextReward.textContent = 'Next reward: 25% off';
      } else if (count === 4) {
        this.nextReward.textContent = 'Next reward: 30% off';
      } else {
        this.nextReward.textContent = 'Top reward unlocked';
      }
    }

    this.root.querySelectorAll('[data-stack-tier]').forEach(function(tier) {
      var tierCount = Number(tier.dataset.stackTier);
      tier.classList.toggle('is-unlocked', count >= tierCount);
      tier.classList.toggle('is-current', count === tierCount);
    });

    if (this.tierFill) {
      var progress = count < 2 ? 0 : Math.min(100, ((count - 2) / (this.maxItems - 2)) * 100);
      this.tierFill.style.width = progress + '%';
    }

    var unlockedTier = count >= 5 ? 5 : (count >= 4 ? 4 : (count >= 3 ? 3 : (count >= 2 ? 2 : 0)));
    this.root.dataset.stackActiveTier = String(unlockedTier);
    if (unlockedTier < this.lastCelebratedTier) {
      this.lastCelebratedTier = unlockedTier;
    } else if (unlockedTier > this.lastCelebratedTier) {
      this.lastCelebratedTier = unlockedTier;
      this.celebrateTier(unlockedTier, rate);
    }

    if (this.currentTotal) {
      this.currentTotal.textContent = formatMoney(current, this.moneyFormat);
      this.currentTotal.classList.toggle('is-discounted', rate > 0);
    }
    if (this.mobileTotal) {
      this.mobileTotal.textContent = formatMoney(current, this.moneyFormat);
    }
    if (this.originalTotal) {
      this.originalTotal.textContent = formatMoney(original, this.moneyFormat);
      this.originalTotal.hidden = rate === 0;
    }
    if (this.saving) {
      this.saving.textContent = rate ? ('You save ' + formatMoney(original - current, this.moneyFormat) + ' (' + rate + '%)') : '';
      this.saving.hidden = rate === 0;
    }

    var buttonLabel = count < 2 ? ('Choose ' + (2 - count) + ' piece' + (count === 0 ? 's' : '')) : (this.editingStackId ? 'Update my stack' : 'Add stack to bag');
    [this.submit, this.mobileSubmit].forEach(function(button) {
      if (!button) {
        return;
      }
      button.disabled = count < 2 || builder.isSubmitting;
      button.textContent = buttonLabel;
    });

    this.cards.forEach(function(card) {
      var selectedCount = builder.selections.filter(function(item) {
        return item.productId === card.dataset.productId;
      }).length;
      var selected = selectedCount > 0;
      var atLimit = count >= builder.maxItems;
      var button = card.querySelector('[data-mellow-quick-add]');
      var text = button && button.querySelector('.mellow-quick-add-button__text');
      var plus = button && button.querySelector('.mellow-quick-add-button__plus');
      var badge = card.querySelector('[data-stack-card-selected-badge]');
      var titleElement = card.querySelector('.mellow-stack-card__title');
      var cardTitle = titleElement ? titleElement.textContent.trim() : 'this piece';

      card.classList.toggle('is-selected', selected);
      card.classList.toggle('is-at-limit', atLimit);
      if (badge) {
        badge.hidden = !selected;
        badge.textContent = selectedCount + ' in your stack';
      }
      if (button) {
        button.disabled = atLimit || button.dataset.productAvailable === 'false';
        button.setAttribute('aria-label', selected ? ('Choose options to add another ' + cardTitle) : ('Choose options for ' + cardTitle));
      }
      if (text) {
        text.textContent = selected ? 'Add another' : 'Add to stack';
      }
      if (plus) {
        plus.textContent = '+';
      }
    });
  };

  Builder.prototype.renderSlot = function(slot, index, selection) {
    if (!selection) {
      slot.className = 'mellow-stack-slot is-empty';
      slot.innerHTML = '<button type="button" class="mellow-stack-slot__empty" data-stack-scroll-products>' +
        '<span class="mellow-stack-slot__number">' + (index + 1) + '</span>' +
        '<span>Choose a piece below</span>' +
      '</button>';
      return;
    }

    slot.className = 'mellow-stack-slot is-filled';
    slot.innerHTML = '<div class="mellow-stack-slot__product">' +
      '<div class="mellow-stack-slot__media">' +
        (selection.image ? '<img class="mellow-stack-slot__image" src="' + escapeHtml(selection.image) + '" alt="">' : '') +
      '</div>' +
      '<div class="mellow-stack-slot__content">' +
        '<p class="mellow-stack-slot__title product__grid__title">' + escapeHtml(selection.title) + '</p>' +
        '<div class="mellow-stack-slot__actions">' +
          '<button type="button" data-stack-edit-slot="' + index + '">Edit options</button>' +
          '<button type="button" data-stack-remove-slot="' + index + '">Remove</button>' +
        '</div>' +
      '</div>' +
    '</div>';
  };

  Builder.prototype.applyCatalogControls = function() {
    var builder = this;
    var query = String((this.search && this.search.value) || '').trim().toLowerCase();
    var filter = this.activeFilter;
    var visible = 0;

    this.cards.forEach(function(card) {
      builder.applyMaterialVariant(card, filter);
      var searchMatches = !query || String(card.dataset.search || '').indexOf(query) !== -1;
      var filterMatches = filter === 'all' || String(card.dataset.materials || '').indexOf(filter) !== -1;
      card.hidden = !(searchMatches && filterMatches);
      if (!card.hidden) {
        visible += 1;
      }
    });

    if (this.grid && this.sort) {
      var value = this.sort.value;
      var cards = this.cards.slice();
      cards.sort(function(a, b) {
        if (value === 'price-asc') {
          return Number(a.dataset.price) - Number(b.dataset.price);
        }
        if (value === 'price-desc') {
          return Number(b.dataset.price) - Number(a.dataset.price);
        }
        if (value === 'rating-desc') {
          return Number(b.dataset.rating || 0) - Number(a.dataset.rating || 0);
        }
        if (value === 'title-asc') {
          return String(a.dataset.title).localeCompare(String(b.dataset.title));
        }
        return 0;
      });
      cards.forEach(function(card) { card.parentNode.appendChild(card); });
    }

    if (this.empty) {
      this.empty.hidden = visible !== 0;
    }
  };

  Builder.prototype.applyMaterialVariant = function(card, materialFilter) {
    var product = card.stackProduct;
    var button = card.querySelector('[data-mellow-quick-add]');
    if (!product || !button || !Array.isArray(product.variants)) {
      return;
    }

    var optionNames = (product.options || []).map(function(option) {
      return typeof option === 'string' ? option : (option && option.name) || '';
    });
    var materialIndex = optionNames.findIndex(function(name) {
      return String(name).toLowerCase().indexOf('material') !== -1;
    });
    var normalizedFilter = this.normalizeMaterial(materialFilter);
    var variant;

    if (materialFilter === 'all') {
      variant = product.variants.find(function(item) {
        return String(item.id) === card.stackDefaultVariantId;
      });
    } else {
      variant = product.variants.find(function(item) {
        if (!item.available) {
          return false;
        }
        var values = item.options || [item.option1, item.option2, item.option3];
        var materialValue = materialIndex >= 0 ? values[materialIndex] : values.join(' ');
        return builderMaterialMatches(materialValue, normalizedFilter);
      });
    }

    if (!variant) {
      return;
    }

    this.applyCardVariant(card, variant, materialFilter === 'all');
  };

  Builder.prototype.applySwatch = function(swatch) {
    var card = swatch.closest('[data-stack-card]');
    var product = card && card.stackProduct;
    if (!card || !product || !Array.isArray(product.variants)) {
      return;
    }

    var button = card.querySelector('[data-mellow-quick-add]');
    var currentVariantId = String((button && button.dataset.variantId) || '');
    var currentVariant = product.variants.find(function(item) {
      return String(item.id) === currentVariantId;
    });

    var optionNames = (product.options || []).map(function(option) {
      return typeof option === 'string' ? option : (option && option.name) || '';
    });
    var optionIndex = parseInt(swatch.dataset.optionIndex, 10);
    var optionValue = String(swatch.dataset.optionValue || '').trim().toLowerCase();
    var currentValues = currentVariant
      ? (currentVariant.options || [currentVariant.option1, currentVariant.option2, currentVariant.option3])
      : [];

    var candidates = product.variants.filter(function(item) {
      var values = item.options || [item.option1, item.option2, item.option3];
      return item.available && String(values[optionIndex] || '').trim().toLowerCase() === optionValue;
    });

    var preservedCandidates = candidates.filter(function(item) {
      var values = item.options || [item.option1, item.option2, item.option3];
      return optionNames.every(function(name, index) {
        if (index === optionIndex || String(name).toLowerCase().indexOf('size') !== -1) {
          return true;
        }

        var currentValue = String(currentValues[index] || '').trim().toLowerCase();
        return !currentValue || String(values[index] || '').trim().toLowerCase() === currentValue;
      });
    });

    var preferredVariant = function(items) {
      return items.find(function(item) { return Boolean(item.featured_image); }) || items[0];
    };
    var variant = preferredVariant(preservedCandidates) || preferredVariant(candidates);

    if (!variant) {
      var fallbackVariantId = String(swatch.dataset.variantId || '');
      variant = product.variants.find(function(item) {
        return String(item.id) === fallbackVariantId;
      });
    }

    if (variant) {
      this.applyCardVariant(card, variant, String(variant.id) === card.stackDefaultVariantId);
    }
  };

  Builder.prototype.applyCardVariant = function(card, variant, restoreDefaultImage) {
    var product = card.stackProduct;
    var button = card.querySelector('[data-mellow-quick-add]');
    if (!product || !button || !variant) {
      return;
    }

    var optionNames = (product.options || []).map(function(option) {
      return typeof option === 'string' ? option : (option && option.name) || '';
    });
    var image = card.querySelector('.mellow-stack-card__image');
    var variantImage = variant.featured_image && (variant.featured_image.src || variant.featured_image.url || variant.featured_image);
    var variantValues = variant.options || [variant.option1, variant.option2, variant.option3];
    var regularOptions = [];

    optionNames.forEach(function(name, index) {
      var value = variantValues[index];
      if (value && value !== 'Default Title' && String(name).toLowerCase().indexOf('size') === -1) {
        regularOptions.push(value);
      }
    });

    if (image && restoreDefaultImage && card.stackDefaultImage) {
      image.src = card.stackDefaultImage.src;
      if (card.stackDefaultImage.srcset) {
        image.setAttribute('srcset', card.stackDefaultImage.srcset);
      } else {
        image.removeAttribute('srcset');
      }
      if (card.stackDefaultImage.sizes) {
        image.setAttribute('sizes', card.stackDefaultImage.sizes);
      } else {
        image.removeAttribute('sizes');
      }
    } else if (image && variantImage) {
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = variantImage;
    }

    var variantLabel = card.querySelector('.mellow-stack-card__variant');
    var priceContainer = card.querySelector('.product__grid__price');
    var price = card.querySelector('.mellow-stack-card__price');
    if (!variantLabel && price) {
      var variantRow = document.createElement('div');
      var priceLink = price.closest('.product__grid__price-link');
      variantRow.className = 'product__grid__variant-row';
      variantLabel = document.createElement('span');
      variantLabel.className = 'mellow-stack-card__variant product__grid__variant-name';
      variantRow.appendChild(variantLabel);
      if (priceLink) {
        priceLink.parentNode.insertBefore(variantRow, priceLink);
      }
    }
    if (variantLabel) {
      variantLabel.textContent = regularOptions.join(', ');
    }
    if (price) {
      price.textContent = formatMoney(variant.price, this.moneyFormat);
      var compareAtPrice = Number(variant.compare_at_price || 0);
      var isOnSale = compareAtPrice > Number(variant.price || 0);
      var compareAt = priceContainer && priceContainer.querySelector('.mellow-stack-card__compare-at');

      price.classList.toggle('on-sale', isOnSale);
      if (isOnSale && priceContainer) {
        if (!compareAt) {
          compareAt = document.createElement('span');
          compareAt.className = 'mellow-stack-card__compare-at compare-at';
          priceContainer.insertBefore(compareAt, price);
        }
        compareAt.textContent = formatMoney(compareAtPrice, this.moneyFormat);
      } else if (compareAt) {
        compareAt.remove();
      }
    }

    card.querySelectorAll('[data-stack-swatch]').forEach(function(swatch) {
      var optionIndex = Number(swatch.dataset.optionIndex);
      var selectedValue = Number.isFinite(optionIndex) && optionIndex >= 0 ? variantValues[optionIndex] : '';
      var normalizedSelected = String(selectedValue || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
      var normalizedSwatch = String(swatch.dataset.optionValue || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
      var active = normalizedSelected !== '' && normalizedSelected === normalizedSwatch;
      if (active) {
        swatch.setAttribute('aria-current', 'true');
        swatch.setAttribute('aria-selected', 'true');
      } else {
        swatch.removeAttribute('aria-current');
        swatch.removeAttribute('aria-selected');
      }
    });

    card.dataset.price = String(variant.price || 0);
    button.dataset.variantId = String(variant.id);
  };

  Builder.prototype.normalizeMaterial = function(value) {
    return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  };

  function builderMaterialMatches(value, normalizedFilter) {
    var normalizedValue = String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
    return normalizedValue.indexOf(normalizedFilter) !== -1;
  }

  Builder.prototype.showError = function(message) {
    if (this.error) {
      this.error.textContent = message || '';
    }
  };

  Builder.prototype.setSubmitting = function(submitting) {
    this.isSubmitting = submitting;
    [this.submit, this.mobileSubmit].forEach(function(button) {
      if (!button) {
        return;
      }
      button.classList.toggle('is-loading', submitting);
      button.setAttribute('aria-busy', submitting ? 'true' : 'false');
      if (submitting) {
        button.disabled = true;
        button.textContent = 'Building your stack…';
      }
    });
    if (!submitting) {
      this.render();
    }
  };

  Builder.prototype.addStackItem = async function(selection, stackId, index, tier) {
    var formData = cloneFormData(selection.entries);
    formData.set('id', selection.variantId);
    formData.set('quantity', '1');
    formData.set('properties[' + STACK_ID_PROPERTY + ']', stackId);
    formData.set('properties[' + STACK_TIER_PROPERTY + ']', String(tier));
    formData.set('properties[' + STACK_POSITION_PROPERTY + ']', String(index + 1));
    formData.set('properties[' + STACK_CODE_PROPERTY + ']', this.codes[tier]);
    formData.set('properties[' + STACK_EDIT_URL_PROPERTY + ']', this.editPageUrl);

    var response = await window.fetch(cartRoute('/add.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      },
      body: formData
    });
    var data = await response.json();

    if (!response.ok) {
      throw new Error(data.description || data.message || 'This piece could not be added. Please try again.');
    }

    return data;
  };

  Builder.prototype.fetchCart = async function() {
    var response = await window.fetch(cartRoute('.js'), { credentials: 'same-origin' });
    if (!response.ok) {
      throw new Error('Your bag could not be refreshed. Please try again.');
    }
    return response.json();
  };

  Builder.prototype.removeOtherStacks = async function(keepStackId) {
    var cart = await this.fetchCart();
    var updates = {};

    (cart.items || []).forEach(function(item) {
      var properties = item.properties || {};
      if (properties[STACK_ID_PROPERTY] && properties[STACK_ID_PROPERTY] !== keepStackId) {
        updates[item.key] = 0;
      }
    });

    if (!Object.keys(updates).length) {
      return;
    }

    var response = await window.fetch(cartRoute('/update.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    });
    if (!response.ok) {
      throw new Error('Your previous stack could not be updated. Please try again.');
    }
  };

  Builder.prototype.removeStackById = async function(stackId) {
    var cart = await this.fetchCart();
    var updates = {};
    (cart.items || []).forEach(function(item) {
      if ((item.properties || {})[STACK_ID_PROPERTY] === stackId) {
        updates[item.key] = 0;
      }
    });
    if (!Object.keys(updates).length) {
      return;
    }
    await window.fetch(cartRoute('/update.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    });
  };

  Builder.prototype.applyDiscount = async function(code) {
    var response = await window.fetch(cartRoute('/update.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: code })
    });
    var data = await response.json();
    if (!response.ok) {
      throw new Error(data.description || data.message || 'Your stack discount could not be applied.');
    }
    return data;
  };

  Builder.prototype.submitStack = async function() {
    if (this.isSubmitting || this.selections.length < 2) {
      return;
    }

    var builder = this;
    var tier = Math.min(this.maxItems, this.selections.length);
    var stackId = createStackId();
    this.showError('');
    this.setSubmitting(true);

    try {
      for (var index = 0; index < this.selections.length; index += 1) {
        await this.addStackItem(this.selections[index], stackId, index, tier);
      }

      await this.removeOtherStacks(stackId);
      await this.applyDiscount(this.codes[tier]);

      this.selections = [];
      this.editingStackId = null;
      this.replaceIndex = null;

      if (window.MellowQuickAdd && typeof window.MellowQuickAdd.refreshCart === 'function') {
        await window.MellowQuickAdd.refreshCart(true);
        syncStackAcceleratedCheckoutButtons();
      } else {
        window.location.href = cartRoute('');
      }
    } catch (error) {
      console.error(error);
      await this.removeStackById(stackId).catch(function(cleanupError) {
        console.error(cleanupError);
      });
      this.showError(error && error.message ? error.message : 'Your stack could not be added. Please try again.');
    } finally {
      this.setSubmitting(false);
    }
  };

  Builder.prototype.loadEditStack = async function() {
    var stackId = new URLSearchParams(window.location.search).get('edit_stack');
    if (!stackId) {
      return;
    }

    try {
      var cart = await this.fetchCart();
      var items = (cart.items || []).filter(function(item) {
        return (item.properties || {})[STACK_ID_PROPERTY] === stackId;
      }).sort(function(a, b) {
        return Number((a.properties || {})[STACK_POSITION_PROPERTY] || 0) - Number((b.properties || {})[STACK_POSITION_PROPERTY] || 0);
      });

      if (!items.length) {
        this.showError('That stack is no longer in your bag. Start a new one below.');
        return;
      }

      this.editingStackId = stackId;
      this.selections = items.slice(0, this.maxItems).map(function(item) {
        var entries = [['id', String(item.variant_id)], ['quantity', '1']];
        Object.keys(item.properties || {}).forEach(function(name) {
          if (name.charAt(0) !== '_') {
            entries.push(['properties[' + name + ']', item.properties[name]]);
          }
        });

        var regular = [];
        var sizes = [];
        (item.options_with_values || []).forEach(function(option) {
          if (String(option.name || '').toLowerCase().indexOf('size') !== -1) {
            sizes.push(option.name + ': ' + option.value);
          } else if (option.value && option.value !== 'Default Title') {
            regular.push(option.value);
          }
        });

        return {
          productId: String(item.product_id),
          handle: String(item.handle || String(item.url || '').split('/products/')[1] || '').split('?')[0],
          title: item.product_title || item.title || '',
          url: item.url || '',
          image: item.featured_image ? (item.featured_image.url || item.featured_image) : (item.image || ''),
          price: Number(item.original_price || item.price || 0),
          variantId: String(item.variant_id),
          variantTitle: item.variant_title || '',
          variantLabel: regular.concat(sizes).join(' · '),
          entries: entries,
          properties: publicProperties(entries),
          product: { id: item.product_id, title: item.product_title, handle: item.handle, options: [] },
          variant: { id: item.variant_id, title: item.variant_title, price: item.original_price || item.price, options: [] }
        };
      });

      this.render();
      this.root.querySelector('[data-stack-slots]').scrollIntoView({ behavior: 'smooth', block: 'center' });
    } catch (error) {
      console.error(error);
      this.showError('Your saved stack could not be loaded. Please try again.');
    }
  };

  function initBuilders(container) {
    var scope = container || document;
    var roots = [];
    if (scope.matches && scope.matches(ROOT_SELECTOR)) {
      roots.push(scope);
    }
    roots = roots.concat(Array.prototype.slice.call(scope.querySelectorAll ? scope.querySelectorAll(ROOT_SELECTOR) : []));

    roots.forEach(function(root) {
      if (!root.dataset.mellowStackInitialised) {
        root.dataset.mellowStackInitialised = 'true';
        root.mellowStackBuilder = new Builder(root);
      }
    });

    syncStackAcceleratedCheckoutButtons();
  }

  async function removeCartStack(button) {
    var stackId = button.dataset.mellowStackRemove;
    if (!stackId || button.disabled) {
      return;
    }

    button.disabled = true;
    button.textContent = 'Removing…';

    try {
      var cartResponse = await window.fetch(cartRoute('.js'), { credentials: 'same-origin' });
      var cart = await cartResponse.json();
      var updates = {};
      (cart.items || []).forEach(function(item) {
        if ((item.properties || {})[STACK_ID_PROPERTY] === stackId) {
          updates[item.key] = 0;
        }
      });

      await window.fetch(cartRoute('/update.js'), {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates, discount: '' })
      });

      if (window.MellowQuickAdd && typeof window.MellowQuickAdd.refreshCart === 'function') {
        await window.MellowQuickAdd.refreshCart(false);
        syncStackAcceleratedCheckoutButtons();
      } else {
        window.location.reload();
      }
    } catch (error) {
      console.error(error);
      button.disabled = false;
      button.textContent = 'Remove stack';
    }
  }

  document.addEventListener('click', function(event) {
    var remove = event.target.closest('[data-mellow-stack-remove]');
    if (remove) {
      event.preventDefault();
      removeCartStack(remove);
      return;
    }

    var edit = event.target.closest('[data-mellow-stack-edit]');
    if (edit) {
      var previewThemeId = new URLSearchParams(window.location.search).get('preview_theme_id');
      if (previewThemeId) {
        event.preventDefault();
        var url = new URL(edit.href, window.location.origin);
        url.searchParams.set('preview_theme_id', previewThemeId);
        window.location.href = url.toString();
      }
    }
  });

  document.addEventListener('click', function(event) {
    var checkout = event.target.closest('button[name="checkout"], input[name="checkout"]');
    if (!checkout || !hasRenderedStack()) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    beginStackCheckout(checkout);
  }, true);

  document.addEventListener('submit', function(event) {
    var submitter = event.submitter || document.activeElement;
    if (!submitter || submitter.name !== 'checkout' || !hasRenderedStack()) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    beginStackCheckout(submitter);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initBuilders(document); });
  } else {
    initBuilders(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initBuilders(event.target);
  });
})();
